import { render } from "./TvmAppointmentAddress.vue?vue&type=template&id=b5c521be&scoped=true"
import script from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"
export * from "./TvmAppointmentAddress.vue?vue&type=script&lang=js"

import "./TvmAppointmentAddress.vue?vue&type=style&index=0&id=b5c521be&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c521be"]])

export default __exports__